import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eaca893"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "SbHistory"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "История проверки СБ", -1))
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "info__title" }
const _hoisted_6 = { class: "info__subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.history.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.history, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `h-item-${idx}`,
            class: _normalizeClass(_ctx.getClass(item.isAccepted))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.getCheckOrTimesIcon(item.isAccepted))
              }, null, 2),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.getTitle(item.isAccepted)), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(item.comment || 'Нет комментария'), 1)
              ])
            ]),
            _createTextVNode(" " + _toDisplayString(item.createdAt), 1)
          ], 2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}